/**
 * Quiet Progress discovery — benefit language, not a “visit the Progress tab”
 * brochure. Used after real wins and next to Settings prefs.
 */

export const PROGRESS_DISCOVERY_AFTER_WIN_LABEL =
  'See what this kitchen has locked in'

export const PROGRESS_DISCOVERY_AFTER_ORDER_LABEL =
  'See how this kitchen is getting more from OMS'

export const PROGRESS_DISCOVERY_SETTINGS_LABEL = 'Open Success Hub'

export const PROGRESS_DISCOVERY_SETTINGS_BODY =
  'Today’s kitchen job, ordering streaks, and what’s already locked in.'

/**
 * @param {string|null|undefined} venueId
 * @returns {string|null}
 */
export function getVenueProgressPath(venueId) {
  const id = String(venueId || '').trim()
  return id ? `/v/${id}/progress` : null
}
